// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchInputStyles } from "@turnerBlueprint/Overrides/Widgets/Header/SearchInput";
import {
    color,
    getSystemColor,
    searchBoxFieldClickableStyles,
    styledScrollbar,
    xScreen,
} from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.tippyPopup = {
    elementWrapper: {
        zIndex: 78888,
        width: "100%",
    },
    main: {
        css: css`
            &.tippy-box {
                ${xScreen("lte", "sm")} {
                    border: none;
                }
                > .tippy-content {
                    padding: 0;
                    ${xScreen("gt", "sm")} {
                        max-height: none;
                        overflow: hidden;
                    }
                }

                ${xScreen("lte", "sm")} {
                    .content-wrapper {
                        overflow: hidden;
                    }
                }
            }
        `,
    },
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        max-height: 400px;
        max-width: 725px;
        overflow: hidden;

        ${xScreen("lte", "md")} {
            max-height: 90vh;
            max-width: none;
            width: 100%;
        }

        ${xScreen("lt", "sm")} {
            flex-direction: column;
            max-height: none;
        }
    `,
};

searchInputStyles.input = {
    ...searchBoxFieldClickableStyles,
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 274px;
        padding: 12px;
        ${xScreen("lte", "md")} {
            width: 288px;
        }
        ${xScreen("lt", "sm")} {
            border-right: 0;
            width: 100%;
            padding: 16px;
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding: 12px;
        width: 452px;
        ${styledScrollbar(8)}
        height: 100%;
        ${({ hasContent }: any) =>
            hasContent &&
            css`
                border-left: 1px solid ${getSystemColor("common.ui5")};
                ${xScreen("lte", "md")} {
                    width: 479px;
                }
            `};

        ${xScreen("lt", "sm")} {
            padding: 16px;
            border-left: none;
            width: auto;
            order: -1;
        }
    `,
};

searchInputStyles.autocompleteColumnProductMobileDivider = {
    css: css`
        display: none;
        ${xScreen("lt", "sm")} {
            height: 1px;
            width: calc(100% - 32px);
            border-top: 1px solid ${color("common.border")};
            margin: 16px auto;
            order: -1;
            display: block;
        }
    `,
};
